import { grayPalette, royalBluePalette } from '../../themes/colors';

export const tooltipLightTheme = {
  backgroundColor: royalBluePalette[1000],
  arrow: {
    color: royalBluePalette[1000],
  },
  textColor: grayPalette[0],
};
